// components/GlobalLoader.js - Modern Standard Version
import { Loader2 } from "lucide-react";
import React from "react";
import { useSelector } from "react-redux";

const GlobalLoader = ({ loading = false }) => {
  const isLoading = useSelector((state) => state.loadingSlice.isLoading);

  if (!isLoading && !loading) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/10 ">
      <div className="flex flex-col items-center space-y-5 p-8">
        <div className="relative">
          <div className="w-10 h-10 border-2 border-gray-100 border-t-blue-500 rounded-full animate-spin"></div>
        </div>
      </div>
    </div>
  );
};

export default GlobalLoader;
